import type { Enums, Nullable } from "../types";

/**
 * This function returns the audit type based on the operation.
 * @param operation
 * @returns
 */
export function getAuditType(operation: Nullable<string | Enums<"operation">>) {
	if (operation === "DELETE") return "audit-delete";
	if (operation === "INSERT") return "audit-insert";
	if (operation === "MERGE") return "audit-merge";
	return "audit-update";
}
